import { render } from "./CollectionHeader.vue?vue&type=template&id=1a2daf36&scoped=true"
import script from "./CollectionHeader.vue?vue&type=script&lang=js"
export * from "./CollectionHeader.vue?vue&type=script&lang=js"

import "./CollectionHeader.vue?vue&type=style&index=0&id=1a2daf36&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a2daf36"]])

export default __exports__